import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/detail/:aid',
    name: 'Detail',
    component: () => import( /* webpackChunkName: "detail" */ '../views/Detail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router